<template>
  <component
    :is="tag"
    class="k-glass-card"
    :class="[`k-glass-${level}`, { 'k-glass-card--padded': padded, 'k-lift': lift }]"
  >
    <slot />
  </component>
</template>

<script>
export default {
  name: "KGlassCard",
  props: {
    level: {
      type: Number,
      default: 1,
      validator: value => [1, 2, 3].includes(value),
    },
    tag: {
      type: String,
      default: "div",
    },
    padded: {
      type: Boolean,
      default: true,
    },
    lift: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.k-glass-card--padded {
  padding: 16px;
}
</style>
